"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryKeys = exports["default"] = void 0;

var _reactQuery = require("react-query");

var _request = require("@nicbase/request");

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _portalQueryKey = _interopRequireDefault(require("./portalQueryKey"));

var _usePortalWidgetTypes3 = _interopRequireDefault(require("./usePortalWidgetTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var overwriteMerge = function overwriteMerge(destinationArray, sourceArray) {
  return sourceArray;
};

var findWidgetsForWorkspace = function findWidgetsForWorkspace(portalId, workspaceId) {
  return {
    type: 'FIND_WIDGETS_BY_WORKSPACE_ID_REQUEST',
    headers: {
      portalId: portalId,
      version: 'v1'
    },
    body: {
      workspaceId: workspaceId
    }
  };
};

var queryKeys = {
  all: function all(portalId) {
    return [].concat(_toConsumableArray((0, _portalQueryKey["default"])(portalId)), ['widgets']);
  }
};
exports.queryKeys = queryKeys;

var usePortalWidgets = function usePortalWidgets(_ref) {
  var portalId = _ref.portalId,
      workspaceId = _ref.workspaceId,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var _usePortalWidgetTypes = (0, _usePortalWidgetTypes3["default"])({
    portalId: portalId
  }),
      _usePortalWidgetTypes2 = _usePortalWidgetTypes.data,
      widgetTypes = _usePortalWidgetTypes2 === void 0 ? [] : _usePortalWidgetTypes2;

  return (0, _reactQuery.useQuery)([].concat(_toConsumableArray(queryKeys.all(portalId)), [workspaceId]), /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _yield$request, body;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return request(findWidgetsForWorkspace(portalId, workspaceId));

          case 2:
            _yield$request = _context.sent;
            body = _yield$request.body;
            return _context.abrupt("return", body === null || body === void 0 ? void 0 : body.widgets);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), _objectSpread({
    enabled: !!workspaceId,
    select: function select(widgets) {
      return widgets.map(function (widget) {
        var id = widget.id,
            type = widget.type,
            layout = widget.layout,
            _widget$settings = widget.settings,
            settings = _widget$settings === void 0 ? {} : _widget$settings;

        var _ref3 = widgetTypes.find(function (widgetType) {
          return widgetType.id === type;
        }) || {},
            _ref3$defaultSettings = _ref3.defaultSettings,
            defaultSettings = _ref3$defaultSettings === void 0 ? {} : _ref3$defaultSettings;

        return _objectSpread(_objectSpread({}, widget), {}, {
          layout: _objectSpread(_objectSpread({}, layout), {}, {
            i: String(id)
          }),
          connectProperties: {
            incoming: {},
            outgoing: {}
          },
          settings: (0, _deepmerge["default"])(defaultSettings, settings, {
            arrayMerge: overwriteMerge
          })
        });
      });
    }
  }, options));
};

var _default = usePortalWidgets;
exports["default"] = _default;